import { AxiosResponse } from 'axios';
import { SET_POSTERS, SET_POSTER, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_POSTER_ISLOADING,
  DELETE_POSTER,
  EDIT_POSTER,
  GET_POSTERS,
  REGISTER_POSTER,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Poster from '@/services/poster';
import { Module } from 'vuex';
import { EditPoster, RegisterPoster, GetPoster } from '@/dtos/poster.dto';

const buildPaginationMeta = (pagination: any, records: any[], payload: any) => {
  const perPage = Number(pagination?.limit ?? pagination?.perPage ?? payload?.limit ?? 20);
  const totalRecords = Number(pagination?.total ?? pagination?.totalRecords ?? records.length);
  const currentPage = Number(pagination?.page ?? payload?.page ?? 1);

  return {
    currentPage,
    perPage,
    totalRecords,
    totalPages: Math.max(Math.ceil(totalRecords / perPage), 1),
  };
};

const poster: Module<any, {}> = {
  state: {
    poster: {
      data: null,
      isLoading: false,
    },
    posters: {
      data: null,
      metaData: null,
      isLoading: false,
    },
  },
  getters: {
    poster: (state: { poster: any }) => state.poster,
    posters: (state: { posters: any }) => state.posters,
  },
  mutations: {
    [SET_POSTER]: (
      state: { poster: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.poster.data = payload.data) : null,
        (state.poster.isLoading = payload.isLoading);
    },
    [SET_POSTERS]: (
      state: { posters: StateObject },
      payload: { data: null; metaData?: any; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.posters.data = payload.data) : null,
        payload.metaData != null ? (state.posters.metaData = payload.metaData) : null,
        (state.posters.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_POSTER]: async ({ commit }: any, payload: FormData) => {
      commit(SET_POSTER, { data: null, isLoading: true });

      const result: AxiosResponse = await Poster.registerPoster(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_POSTER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_POSTER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_POSTER, { isLoading: false });
        return false;
      }
    },
    [GET_POSTERS]: async ({ commit }: any, payload: any) => {
      commit(SET_POSTERS, { data: null, isLoading: true });

      const result: AxiosResponse = await Poster.getPosters(
        payload as GetPoster
      );

      if (result) {
        if (result.data.status) {
          const responseData = result.data.data;
          const records = Array.isArray(responseData) ? responseData : responseData?.data || [];
          const metaData = buildPaginationMeta(
            result.data.pagination || result.data.metaData || responseData?.pagination || responseData?.metaData,
            records,
            payload
          );
          commit(SET_POSTERS, { data: records, metaData, isLoading: false });
          return true;
        }
        commit(SET_POSTERS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_POSTERS, { isLoading: false });
        return false;
      }
    },
    [EDIT_POSTER]: async ({ commit }: any, payload: FormData) => {
      commit(SET_POSTER, { data: null, isLoading: true });

      const result: AxiosResponse = await Poster.editPoster(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_POSTER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_POSTER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_POSTER, { isLoading: false });
        return false;
      }
    },
    [DELETE_POSTER]: async ({ commit }: any, payload: string) => {
      commit(SET_POSTER, { data: null, isLoading: true });

      const result: AxiosResponse = await Poster.deletePoster(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_POSTER, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_POSTER, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_POSTER, { isLoading: false });
        return false;
      }
    },
    [CLEAR_POSTER_ISLOADING]: ({ commit }) => {
      commit(SET_POSTER, { isLoading: false });
      commit(SET_POSTERS, { isLoading: false });
    },
  },
};

export default poster;
